import { Graphics } from '../../scopeData/types';
import { APIEntityType, ArdoqId } from '@ardoq/api-types';
import {
  getComponentColor,
  getComponentRepresentationData,
  getComponentTypeColor,
  getComponentTypeRepresentationData,
} from '../../scopeData/utils/colorsAndRepresentations';
import { CSSProperties } from 'react';
import {
  representationDataToEntityIconProps,
  EntityIcon,
} from '@ardoq/basic-components';
import type { EnhancedScopeData } from '@ardoq/data-model';

const ComponentIconRepresentation = ({
  entityId,
  entityType,
  parentEntityId,
  enhancedScopeData,
  graphics,
  style,
}: {
  entityId: ArdoqId;
  entityType: APIEntityType.COMPONENT_TYPE | APIEntityType.COMPONENT;
  enhancedScopeData: EnhancedScopeData;
  graphics: Graphics;
  parentEntityId?: ArdoqId;
  style?: CSSProperties;
}) => {
  const { isImage, icon, value } =
    entityType === APIEntityType.COMPONENT_TYPE
      ? getComponentTypeRepresentationData(
          entityId,
          parentEntityId,
          enhancedScopeData
        )
      : getComponentRepresentationData(entityId, enhancedScopeData);

  const color =
    entityType === APIEntityType.COMPONENT_TYPE
      ? getComponentTypeColor(entityId, parentEntityId!, enhancedScopeData)
      : getComponentColor(entityId, enhancedScopeData);

  if (
    (entityType === APIEntityType.COMPONENT_TYPE &&
      icon === graphics.icons.none) ||
    (entityType === APIEntityType.COMPONENT && !value)
  ) {
    return null;
  }

  return (
    <EntityIcon
      {...representationDataToEntityIconProps({
        style: { color, ...(style ?? {}) },
        isImage,
        value,
        icon,
      })}
    />
  );
};

export { ComponentIconRepresentation };
